/**
 * The realtime connection's per-attempt token (TO-468). Reads the stored access
 * token at attempt time and refreshes it first when it expires within 60 s, so a
 * reconnect never presents a dead token to the authorizer.
 */
import { authService } from '@/services/auth.service'

const REFRESH_MARGIN_SECONDS = 60

/** Seconds-since-epoch expiry of a JWT, or `undefined` when unreadable. */
function jwtExpiry(token: string): number | undefined {
	try {
		const payload = token.split('.')[1]
		if (!payload) return undefined
		const json = atob(payload.replace(/-/g, '+').replace(/_/g, '/'))
		const { exp } = JSON.parse(json) as { exp?: unknown }
		return typeof exp === 'number' ? exp : undefined
	} catch {
		return undefined
	}
}

/** The access token for one connection attempt, or `null` (the attempt fails and backs off). */
export async function getRealtimeToken(): Promise<string | null> {
	const token = localStorage.getItem('accessToken')
	if (!token) return null
	const exp = jwtExpiry(token)
	if (exp !== undefined && exp - Date.now() / 1000 > REFRESH_MARGIN_SECONDS) return token
	try {
		return await authService.refresh()
	} catch {
		return null
	}
}
